import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { calculateRem } from '@uie/javascript-style-helpers';
import { Checkbox as CoreCheckbox } from '@vds-core/inputs';
import { BodyConfig, TypographyConfig } from '@vds/typography';
import CheckboxIcon from './CheckboxIcon';

var Checkbox = function Checkbox(props) {
  var checkboxMarginRight = calculateRem(8);
  var errorMargin = calculateRem(5);
  var marginBottom = calculateRem(20);
  var maxWidth = 'auto';
  return /*#__PURE__*/React.createElement(CoreCheckbox, _extends({}, props, {
    focusState: false,
    typescale: TypographyConfig.getTypescale(),
    CheckboxIcon: CheckboxIcon,
    bodyConfig: BodyConfig,
    checkboxMarginRight: checkboxMarginRight,
    errorMargin: errorMargin,
    marginBottom: marginBottom,
    maxWidth: maxWidth,
    hitAreaLabelMargin: false,
    label: undefined
  }));
};

export default Checkbox;